export const policyViolationsInitialState = {

  // --- List ---
  records: [],
  totalCount: 0,
  listLoading: false,
  listError: null,

  // --- Aggregate: count by control type (feeds the 3 stat tiles) ---
  countByType: [],
  countByTypeLoading: false,
  countByTypeError: null,

  // --- Aggregate: count by category (fetched per the API contract; available for a
  // future category-breakdown widget, not yet visualized beyond the sortable column) ---
  countByCategory: [],
  countByCategoryLoading: false,
  countByCategoryError: null,

  // --- Filters shared across all 3 endpoints (list + both aggregate calls), so the
  // stat tiles and the table underneath always reflect the same sub-tab and window ---
  filters: {
    page: 1,
    pageSize: 50,
    search: '',
    sortBy: 'detectedOn',
    sortDir: 'desc',
    controlType: 'DATA', // active sub-tab: 'DATA' (default) | 'WEB,AI'
    dateRange: 'last90d',
    fromDate: null,
    toDate: null,
  },
}
